// extracted by mini-css-extract-plugin
export default {"title":"LeftSide_title__AEMU-","space":"LeftSide_space__tgc69","list":"LeftSide_list__pP1NN","footer":"LeftSide_footer__aMqDv"};